<script setup lang="ts">
    import { Info } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';

    defineProps<{
        missingVouchers: number;
        totalVouchers: number;
    }>();
</script>

<template>
    <HoverCardRoot
        :open-delay="0"
        :close-delay="0"
    >
        <HoverCardTrigger>
            <div
                class="border-primary/20 bg-primary/10 flex items-center gap-2 rounded-md border p-2 text-xs"
            >
                <span>
                    <span class="font-bold"> {{ missingVouchers }} / {{ totalVouchers }} </span>
                    {{ $t('vouchers.missing-text') }}
                </span>
                <Info class="text-secondary/50 size-3.5" />
            </div>
        </HoverCardTrigger>
        <HoverCardPortal>
            <HoverCardContent
                class="animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-[300px] rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all"
                :side-offset="5"
            >
                <div class="mb-2 flex items-center gap-2 text-xs font-bold">
                    <Info class="text-secondary size-5" />
                    {{ $t('vouchers.help.title') }}
                </div>
                <p class="text-xs">{{ $t('vouchers.help.content') }}</p>
            </HoverCardContent>
        </HoverCardPortal>
    </HoverCardRoot>
</template>
